// Spectrum 2 "AI Sparkles" icon (S2_Icon_AISparkles_20_N). The installed
// @react-spectrum/s2 build doesn't ship this icon, so it's vendored here as a
// plain SVG that inherits color via currentColor and renders at the S2 20px size.
export const AISparklesIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fill="currentColor"
				d="M7.93454 10.5993C7.75954 10.5993 7.58298 10.554 7.42361 10.4618C7.03845 10.2391 6.84392 9.79771 6.93845 9.36334L7.52048 6.66412L5.66579 4.61802C5.36735 4.28834 5.31579 3.80865 5.53845 3.4235C5.7611 3.03756 6.20642 2.84302 6.63689 2.93834L9.3361 3.52037L11.3822 1.66568C11.7127 1.36568 12.1924 1.31646 12.5767 1.53834C12.9619 1.76099 13.1564 2.2024 13.0619 2.63678L12.4799 5.33599L14.3345 7.38209C14.633 7.71099 14.6838 8.19068 14.4619 8.57584C14.2392 8.96022 13.7994 9.15631 13.3642 9.06256L10.665 8.47897L8.61814 10.3344C8.42518 10.5094 8.18063 10.5993 7.93454 10.5993ZM8.71345 6.82662L8.22986 9.06646L9.92751 7.5274C10.1697 7.30787 10.5041 7.21724 10.8252 7.28599L13.0666 7.77037L11.5275 6.07271C11.3072 5.82896 11.2174 5.49224 11.2877 5.17193L11.7705 2.93365L10.0728 4.47271C9.82908 4.69302 9.49314 4.78209 9.17205 4.71255L6.93377 4.22974L8.47283 5.92739C8.69314 6.17036 8.78298 6.50631 8.71345 6.82662Z"
			/>
			<path
				fill="currentColor"
				d="M2.67656 14.6016C2.57343 14.6016 2.47031 14.575 2.37656 14.5211C2.15078 14.3906 2.03515 14.1297 2.08984 13.875L2.33515 12.7406L1.55546 11.8812C1.38046 11.6883 1.34999 11.4039 1.48046 11.1781C1.61094 10.9523 1.87343 10.8398 2.12656 10.8914L3.26094 11.1367L4.12031 10.357C4.31406 10.1812 4.59687 10.1515 4.82344 10.282C5.04922 10.4125 5.16485 10.6734 5.11016 10.9281L4.86485 12.0625L5.64454 12.9219C5.81954 13.1148 5.85001 13.3992 5.71954 13.625C5.58906 13.8508 5.32578 13.9617 5.07344 13.9117L3.93906 13.6664L3.07969 14.4461C2.96641 14.5484 2.82187 14.6016 2.67656 14.6016Z"
			/>
		</svg>
	);
};
